const onWindowLoad = () => {
  const nav = document.querySelector('.nav');

  const dropdownWrapper = document.querySelector('.dropdown-wrapper');

  if (!nav) return;

  let timer = null;
  let position = 0;
  window.addEventListener('scroll', () => {
    if (timer !== null) {
      clearTimeout(timer);
    }

    if (window.scrollY > 100) {
      nav.style.transform = 'translate(0, -80px)';

      if (dropdownWrapper) {
        dropdownWrapper.style.top = '-1px';
        dropdownWrapper.style.position = 'sticky';
      }
    }
    if (position > window.scrollY || window.scrollY < 100) {
      nav.style.transform = 'translate(0, 0px)';
      if (dropdownWrapper) dropdownWrapper.style.position = 'relative';
    }

    timer = setTimeout(() => {
      position = window.scrollY;
    }, 100);
  }, false);

};

export default onWindowLoad;
